import React, { Component, createContext, useContext } from 'react'
import { Auth0Context } from '@auth0/auth0-react'

// create the context
export const ArticlesContext = createContext({})
export const useArticles = () => useContext(ArticlesContext)

class ArticlesProvider extends Component {
    static contextType = Auth0Context

    state = {
        filters: [],
        selections: [],
        search: null
    }

    setFilters = (new_filters) => {
        this.setState({
            filters: new_filters,
        })
    }

    setSelections = (new_selection) => {
        this.setState({
            selections: new_selection,
        })
    }

    setSearchText = (new_search) => {
        this.setState({
            search: new_search,
        })
    }

    render() {
        const {
            selections,
            filters,
            search
        } = this.state

        const { children } = this.props

        const configObject = {
            selections,
            filters,
            searchText: search,
            setFilters: (new_active_filters) => this.setFilters(new_active_filters),
            setSelections: (new_selections) => this.setSelections(new_selections),
            setSearchText: (new_search) => this.setSearchText(new_search)
        }

        return <ArticlesContext.Provider value={configObject}>{children}</ArticlesContext.Provider>
    }
}

export default ArticlesProvider
